import { render, staticRenderFns } from "./ribbonButton.vue?vue&type=template&id=68701c2b"
import script from "./ribbonButton.vue?vue&type=script&lang=js"
export * from "./ribbonButton.vue?vue&type=script&lang=js"
import style0 from "./ribbonButton.vue?vue&type=style&index=0&id=68701c2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports